import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useState } from 'react';

function Sidebar() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const closeSidebar = () => setIsOpen(false);

  return (
    <>
      {/* Hamburger Button */}
      <button className="hamburger" onClick={() => setIsOpen(!isOpen)}>
        {isOpen ? '✕' : '☰'}
      </button>

      {/* Overlay */}
      <div
        className={`sidebar-overlay ${isOpen ? 'show' : ''}`}
        onClick={closeSidebar}
      />

      {/* Sidebar */}
      <div className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-logo">
          <h2>ClientPortal</h2>
          <p>Admin Panel</p>
        </div>

        <nav className="sidebar-nav">
          <Link to="/admin/dashboard" onClick={closeSidebar}>📊 Dashboard</Link>
          <Link to="/admin/clients" onClick={closeSidebar}>👥 Clients</Link>
          <Link to="/admin/projects" onClick={closeSidebar}>📁 Projects</Link>
          <Link to="/admin/files" onClick={closeSidebar}>📎 Files</Link>
          <Link to="/admin/invoices" onClick={closeSidebar}>💰 Invoices</Link>
          <Link to="/admin/messages" onClick={closeSidebar}>💬 Messages</Link>
        </nav>

        <button className="sidebar-logout" onClick={handleLogout}>
          🚪 Logout
        </button>
      </div>
    </>
  );
}

export default Sidebar;